<div class="main">
    <div class="container-fluid">
        <!-- Header Section -->
        <div class="tenders-header d-flex flex-wrap justify-content-between align-items-center m-4">
            <div class="tenders-title-container mb-3 mb-md-0">
                <button class="btn back-btn p-0 mb-2 d-flex align-items-center" (click)="goBack()" aria-label="Go back to Evaluations">
                    <i class="fas fa-arrow-left me-2"></i>
                    Go back to Evaluations
                </button>
                <h3>My Evaluation - Scoring</h3>
                <span>
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="tenders-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <a [routerLink]="['/' + AppConstants.ROUTES.EVALUATIONS]" class="tenders-header-title breadcrumb-link">Evaluations <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span>My Evaluation - Scoring</span>
                </span>
            </div>
        </div>

        <!-- Form Section -->
        <div class="mandatory-application m-4">
            <div class="inside-out p-4">
                <!-- Read-only Banner -->
                <div *ngIf="isReadOnly" class="alert alert-info d-flex align-items-center mb-4" role="alert">
                    <i class="fas fa-info-circle me-2"></i>
                    <span>This evaluation has already been submitted and is in read-only mode.</span>
                </div>
                <div *ngIf="evaluationDetails.reviewComments" class="alert alert-warning mb-4" role="alert">
                    <strong>Secretary change request:</strong> {{ evaluationDetails.reviewComments }}
                </div>
                <div class="mandatory-fields"></div>
                <form [formGroup]="scoringForm" (ngSubmit)="onSubmit()">
                    <div class="container pt-4">
                        <div class="mandatory-line" *ngIf="!isReadOnly">
                            <span class="mandatory-par">
                                Mandatory fields below are marked with <span style="color: red;font-size: 1rem;">*</span>
                            </span>
                        </div>
                        <br *ngIf="!isReadOnly">

                        <!-- Evaluation Details Section -->
                        <div class="evaluation-details-section">
                            <div class="details-grid">
                                <div class="detail-item">
                                    <label class="detail-label">PR</label>
                                    <div class="detail-value">{{ evaluationDetails.prNumber }}</div>
                                </div>
                                <div class="detail-item">
                                    <label class="detail-label">Evaluation Type</label>
                                    <div class="detail-value">{{ evaluationDetails.evaluationType || 'Technical' }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- Evaluation Report Section -->
                        <div class="evaluation-report-section">
                            <div class="form-section mb-4">
                                <label class="form-label fw-bold mb-3 d-block">Evaluation Report <span style="color: red;font-size: 1rem;">*</span></label>
                                <app-file-upload
                                    #fileUploadComponent
                                    label=""
                                    placeholderText="Click or drag files here to upload your evaluation report"
                                    [multiple]="true"
                                    inputId="agenda-attachments-upload"
                                    [isRequired]="true"
                                    [formControl]="$any(scoringForm.get('evaluationReport'))"
                                    [disabled]="isReadOnly">
                                </app-file-upload>
                            </div>

                            <div class="text-danger" *ngIf="scoringForm.get('evaluationReport')?.invalid && scoringForm.get('evaluationReport')?.touched">
                                This field is required
                            </div>
                        </div>

                        <!-- Recommendation Section -->
                        <div class="recommendation-section">
                            <h4 class="fw-bold mb-4 mt-5">Recommendation {{ isReadOnly ? '' : '(Optional)' }}</h4>
                            <input
                                type="text"
                                formControlName="recommendation"
                                class="form-control recommendation-input"
                                [placeholder]="isReadOnly ? '' : 'Enter your recommendation'"
                                [readonly]="isReadOnly"
                                [attr.aria-label]="'Recommendation (optional)'">
                        </div>

                        <!-- General Remarks Section -->
                        <div class="general-remarks-section">
                            <label for="generalRemarks" class="form-label fw-bold mb-3 mt-5 d-block">General Remarks <span style="color: red;font-size: 1rem;">*</span></label>
                            <textarea
                                id="generalRemarks"
                                formControlName="generalRemarks"
                                class="form-control general-remarks-textarea"
                                rows="6"
                                [placeholder]="isReadOnly ? '' : 'Enter your overall comments, observations, and any additional notes regarding this evaluation'"
                                [readonly]="isReadOnly"
                                [class.is-invalid]="scoringForm.get('generalRemarks')?.invalid && scoringForm.get('generalRemarks')?.touched"
                                [attr.aria-label]="'General remarks'"></textarea>
                            <div class="text-danger" *ngIf="scoringForm.get('generalRemarks')?.invalid && scoringForm.get('generalRemarks')?.touched">
                                This field is required
                            </div>
                        </div>

                        <!-- Received Bids and Bid Cards -->
                        <ng-container *ngIf="allBids.length > 0">
                            <div class="received-bids-header">
                                <h4 class="received-bids-title">Received Bids for This Tender <span class="required-asterisk">*</span></h4>
                                <p class="received-bids-instruction">Review and evaluate each bid individually. Upload the evaluation report and provide your recommendation.</p>
                            </div>

                            <div *ngFor="let bid of allBids; trackBy: trackByBidId" class="bid-info-card mb-4">
                                <div class="bid-header-section">
                                    <div class="bid-info">
                                        <div class="bid-header">
                                            <span class="bid-id-vendor">{{ bid.bidId }} {{ bid.vendorName }}</span>
                                            <svg class="document-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="viewDocuments(bid); $event.stopPropagation()" style="cursor: pointer;">
                                                <path d="M9.99935 1.33331H3.99935C3.64573 1.33331 3.30659 1.47379 3.05654 1.72384C2.80649 1.97389 2.66602 2.31302 2.66602 2.66665V13.3333C2.66602 13.6869 2.80649 14.0261 3.05654 14.2761C3.30659 14.5262 3.64573 14.6666 3.99935 14.6666H11.9993C12.353 14.6666 12.6921 14.5262 12.9422 14.2761C13.1922 14.0261 13.3327 13.6869 13.3327 13.3333V4.66665L9.99935 1.33331Z" stroke="#6B4C7C" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M9.33398 1.33331V3.99998C9.33398 4.3536 9.47446 4.69274 9.72451 4.94279C9.97456 5.19284 10.3137 5.33331 10.6673 5.33331H13.334" stroke="#6B4C7C" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M6.66732 6H5.33398" stroke="#6B4C7C" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M10.6673 8.66669H5.33398" stroke="#6B4C7C" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M10.6673 11.3333H5.33398" stroke="#6B4C7C" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </div>
                                        <div class="bid-details">
                                            <span class="bid-date">Submitted: {{ bid.submissionDate }}</span>
                                        </div>
                                    </div>
                                    <div class="bid-actions">
                                        <button
                                            type="button"
                                            class="btn approve-btn"
                                            [class.selected]="getBidDecision(bid.bidId) === 'approved'"
                                            [class.not-selected]="getBidDecision(bid.bidId) === 'rejected'"
                                            [disabled]="isReadOnly || bid.canChangeDecision === false"
                                            (click)="onApprove(bid)">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            Approve
                                            <span *ngIf="getBidDecision(bid.bidId) === 'approved'" class="decision-badge approved">✓ Selected</span>
                                        </button>
                                        <button
                                            type="button"
                                            class="btn reject-btn"
                                            [class.selected]="getBidDecision(bid.bidId) === 'rejected'"
                                            [class.not-selected]="getBidDecision(bid.bidId) === 'approved'"
                                            [disabled]="isReadOnly || bid.canChangeDecision === false"
                                            (click)="onReject(bid)">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            Reject
                                            <span *ngIf="getBidDecision(bid.bidId) === 'rejected'" class="decision-badge rejected">✗ Selected</span>
                                        </button>
                                    </div>
                                </div>
                                <div class="text-danger small mt-2" *ngIf="bid.canChangeDecision === false">
                                    Rejected in evaluation. The Secretary must unseal this bid's commercial proposal before its decision can be changed.
                                </div>

                                <div class="general-remarks-section-card">
                                    <label class="general-remarks-label">General Remarks</label>
                                    <textarea
                                        class="form-control general-remarks-textarea-card"
                                        rows="4"
                                        [placeholder]="isReadOnly ? '' : 'Enter your comments and observations for this bid'"
                                        [value]="getBidRemarks(bid.bidId)"
                                        (input)="onBidRemarksChange(bid.bidId, $any($event.target).value)"
                                        [readonly]="isReadOnly"
                                        [attr.aria-label]="'General remarks'"></textarea>
                                </div>
                            </div>
                        </ng-container>

                        <div *ngIf="allBids.length === 0" class="alert alert-info mt-4 mb-0">
                            No submitted bids are available for this evaluation.
                        </div>
                    </div>

                    <!-- Footer Buttons -->
                    <div class="form-footer">
                        <button type="button" class="btn cancel-btn" (click)="onCancel()">{{ isReadOnly ? 'Back' : 'Cancel' }}</button>
                        <button *ngIf="!isReadOnly" type="button" class="btn save-draft-btn" (click)="onSaveDraft()">Save as Draft</button>
                        <button *ngIf="!isReadOnly" type="submit" class="btn submit-btn">Submit Evaluation</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!-- Documents Dialog -->
    <div class="documents-dialog-overlay" *ngIf="showDocumentsDialog" (click)="closeDocumentsDialog()">
        <div class="documents-dialog" (click)="$event.stopPropagation()">
            <!-- Header -->
            <div class="dialog-header">
                <div class="header-content">
                    <h3 class="dialog-title">Bid Documents</h3>
                    <p class="dialog-subtitle" *ngIf="currentBidForDocuments">{{ currentBidForDocuments.bidId }} - {{ currentBidForDocuments.vendorName }}</p>
                </div>
                <button class="close-btn" (click)="closeDocumentsDialog()" aria-label="Close">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 5L5 15M5 5L15 15" stroke="#333" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>

            <!-- Content -->
            <div class="dialog-content">
                <div class="no-documents" *ngIf="isLoadingAttachments">
                    <p>Loading documents...</p>
                </div>
                <div class="documents-list" *ngIf="!isLoadingAttachments && documents.length > 0">
                    <div *ngFor="let document of documents; trackBy: trackByDocument" class="document-item">
                        <div class="document-icon">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.4987 1.66667H4.9987C4.55667 1.66667 4.13275 1.84226 3.82019 2.15482C3.50763 2.46738 3.33203 2.89131 3.33203 3.33333V16.6667C3.33203 17.1087 3.50763 17.5326 3.82019 17.8452C4.13275 18.1577 4.55667 18.3333 4.9987 18.3333H14.9987C15.4407 18.3333 15.8646 18.1577 16.1772 17.8452C16.4898 17.5326 16.6654 17.1087 16.6654 16.6667V5.83333L12.4987 1.66667Z" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.668 1.66667V5C11.668 5.44203 11.8436 5.86595 12.1561 6.17851C12.4687 6.49107 12.8926 6.66667 13.3346 6.66667H16.668" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M8.33464 7.5H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.3346 10.8333H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.3346 14.1667H6.66797" stroke="#6B4C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <ng-container *ngIf="!isEvaluationBidDocumentSealed(document); else sealedEvaluationDocument">
                            <div class="document-info">
                                <div class="document-name">{{ document.name }}</div>
                                <div class="document-size">
                                    <span *ngIf="document.attachmentFor">{{ document.attachmentFor }}</span>
                                    <!-- <span *ngIf="document.attachmentFor"> - </span>
                                    <span>{{ document.size }}</span> -->
                                    <span *ngIf="document.uploadedDate"> - Uploaded {{ document.uploadedDate | date: 'yyyy-MM-dd' }}</span>
                                    <span *ngIf="document.expiryDate"> - Expires {{ document.expiryDate | date: 'yyyy-MM-dd' }}</span>
                                </div>
                            </div>
                            <button class="btn download-btn" (click)="downloadDocument(document)">
                                Download
                            </button>
                        </ng-container>
                        <ng-template #sealedEvaluationDocument>
                            <div class="document-info sealed-document-info">
                                <div class="document-name">{{ document.attachmentFor || 'Bid document' }}</div>
                                <div class="document-size">Document sealed</div>
                            </div>
                        </ng-template>
                    </div>
                </div>
                <div class="no-documents" *ngIf="!isLoadingAttachments && documents.length === 0">
                    <p>No documents available</p>
                </div>
            </div>

            <!-- Footer -->
            <div class="dialog-footer">
                <button class="btn close-button" (click)="closeDocumentsDialog()">Close</button>
            </div>
        </div>
    </div>

    <!-- Confirmation Dialog -->
    <div class="confirmation-dialog-overlay" *ngIf="showConfirmDialog" (click)="cancelAction()">
        <div class="confirmation-dialog" (click)="$event.stopPropagation()">
            <div class="dialog-content">
                <p>{{ getConfirmDialogMessage() }}</p>
            </div>
            <div class="dialog-footer">
                <button class="btn btn-cancel" (click)="cancelAction()">Cancel</button>
                <button class="btn" [class.btn-approve]="pendingAction === 'approved'" [class.btn-reject]="pendingAction === 'rejected'" (click)="confirmAction()">{{ pendingAction === 'approved' ? 'Approve' : 'Reject' }}</button>
            </div>
        </div>
    </div>
</div>
